<!-- =========================================================================================
    File Name: Register.vue
    Description: Register Page
========================================================================================== -->

<template>
  <div
    class="h-screen flex w-full bg-img vx-row no-gutter items-center justify-center"
    id="page-login"
  >
    <div class="vx-col sm:w-1/2 md:w-1/2 lg:w-3/4 xl:w-3/5 sm:m-0 m-4">
      <vx-card>
        <div slot="no-body" class="full-page-bg-color">
          <div class="vx-row no-gutter justify-center items-center">
            
            <div class="vx-col sm:w-full md:w-full lg:w-1/2 d-theme-dark-bg">
              <div class="d-flex justify-content-center">
                <img :src="logo"/>
              </div>
            </div>
            <div class="vx-col sm:w-full md:w-full lg:w-1/2 d-theme-dark-bg">
              <div class="p-8 login-tabs-container">
                <div class="vx-card__title mb-4">
                  <h4 class="mb-4">Register for <b>{{getDomain()}}</b> customer portal</h4>
                </div>

                <div>
                  <vs-input
                    name="user"
                    icon-no-border
                    icon="icon icon-user"
                    icon-pack="feather"
                    label-placeholder="User"
                    v-model="user"
                    class="w-full"
                  />
                  <vs-input
                    type="email"
                    name="email"
                    icon-no-border
                    icon="icon icon-mail"
                    icon-pack="feather"
                    label-placeholder="Email"
                    v-model="email"
                    class="w-full"
                  />
                  <vs-input
                    type="password"
                    name="password"
                    icon-no-border
                    icon="icon icon-lock"
                    icon-pack="feather"
                    label-placeholder="Password"
                    v-model="password"
                    class="w-full mt-6"
                  />
                  <vs-input
                    type="password"
                    name="password"
                    icon-no-border
                    icon="icon icon-lock"
                    icon-pack="feather"
                    label-placeholder="Confirm password"
                    v-model="repassword"
                    class="w-full mt-6"
                  />
                  <div class="flex flex-wrap justify-between my-5"></div>
                  <vs-button :to="getRelativeLink('/')" type="border">Login</vs-button>
                  <vs-button class="float-right" @click="signUp"
                    >Register</vs-button
                  >
                </div>
              </div>
            </div>
          </div>
        </div>
      </vx-card>
    </div>
  </div>
</template>

<script>
export default {
  data() {
    return {
      user: "",
      email: "",
      password: "",
      repassword: "",
      email_reg: /^(([^<>()\\[\]\\.,;:\s@"]+(\.[^<>()\\[\]\\.,;:\s@"]+)*)|(".+"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,24}))$/,
      logo: "",
    };
  },
  created() {
    if (this.$route.query.failed) {
      this.alertUser("danger", "User could not be created! " + this.$route.query.error, 4000);
      this.user = this.$route.query.user.replace(this.getDomain() + ".", "");
      this.email = this.$route.query.email;
    }
    this.getLogos(this.getDomain());
  },
  methods: {
    signUp() {
      if (this.user == "") {
        this.alertUser("danger", "Please enter your username");
      } else if (this.email == "") {
        this.alertUser("danger", "Please enter your email");
      } else if (this.email_reg.test(this.email) == false) {
        this.alertUser("danger", "Please enter a vaild email");
      } else if (this.password == "") {
        this.alertUser("danger", "Please enter a password");
      } else if (this.password.length < 6) {
        this.alertUser("danger", "Password must be at least 6 characters long", 4000)
      } else if (this.repassword == "") {
        this.alertUser("danger", "Please confirm your password");
      } else if (this.password != this.repassword) {
        this.alertUser(
          "danger",
          "Password and confirmation password do not match"
        );
      } else {
        this.createMyUser();
      }
    },
    async createMyUser() {
      const urlWithParams = new URL(
        "https://ezzybills.ezzydoc.com/Account/RegisterMyUser"
      );
      urlWithParams.searchParams.append("name", this.getScopedUser(this.user));
      urlWithParams.searchParams.append("password", this.password);
      urlWithParams.searchParams.append("email", this.email);
      urlWithParams.searchParams.append("type", "2");

      window.location.href = urlWithParams.href;
    },
  },
};
</script>

<style lang="scss">
#page-login {
  .social-login-buttons {
    .bg-facebook {
      background-color: #1551b1;
    }

    .bg-twitter {
      background-color: #00aaff;
    }

    .bg-google {
      background-color: #4285f4;
    }

    .bg-github {
      background-color: #333;
    }
  }
}
</style>
